/* eslint-disable */ 
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr"
import SessionService from '@/services/SessionService'
import {LOGIN_URL, SITE_NAME} from '@/config'

function defaultClient(){
  return new HubConnectionBuilder()
  .withUrl('/turnoOnlineHub', { accessTokenFactory: () =>  SessionService.getToken() })
  .configureLogging(LogLevel.None)
  .withAutomaticReconnect()
  .build()
}

export default function createWebSocketPlugin(client = defaultClient()){
  return store => {
    // change connection status flag
    client.on('stateChanged', (oldState, newState) => {
      if (oldState !== newState && newState !== 'Connected')
        store.dispatch('turnos/connectionClosed')
      else store.dispatch('turnos/connectionOpened')
    })

    // start websocket conection to backend
    store.subscribe((mutation,state) =>{
      if(!state.turnos.connected && mutation.type === 'session/connection' && client.state === 'Disconnected'){
        client.start().then(() => {
          store.dispatch('turnos/connectionOpened')
        }).catch((err) => {
          store.dispatch('turnos/connectionError', err)
          handleError(err.toString())
        })
      }
    })

    // setup endpoint 'ListaTurno'
    client.on('ListaTurno', response => {
      store.dispatch('turnos/setTurnos',response)
    })

    // setup endpoint 'ListaModificada'
    client.on('ListaModificada', response => {
      store.dispatch('turnos/setTurnos',response)
    })

    // setup endpoint 'MisTurnos'
    client.on('MisTurnos', response => {
      store.dispatch('turnos/setMisTurnos', response)
    })

    // setup endpoint 'Mensaje'
    client.on('Mensaje', response => {
      store.dispatch('snackbar/showSnackbar', [response, 'warning','Cerrar'])
    })

    // setup endpoint 'OperacionTerminada'
    client.on('OperacionTerminada', response =>{
      store.dispatch('turnos/setOperacionFlag', response)
    })

    // send for store mutation 'turnos/getLista' and send message to backend to 'Lista' endpoint
    store.subscribe((mutation, state) =>{
      if(state.turnos.connected && mutation.type === 'turnos/getLista'){
        // eslint-disable-next-line no-console
        client.send(mutation.payload.endpoint).catch(err => console.error(err))
      }
    })

    // send method para reservar turno
    store.subscribe((mutation, state) =>{
      if(state.turnos.connected && mutation.type === 'turnos/reservarTurno'){
        // eslint-disable-next-line no-console
        client.send(mutation.payload.endpoint, mutation.payload.turno, mutation.payload.idPaciente, mutation.payload.numeroNotificacion).catch(err => console.error(err))
      }
    })

    // send method para anular turno reservado
    store.subscribe((mutation, state) =>{
      if(state.turnos.connected && mutation.type === 'turnos/anularTurno'){
        // eslint-disable-next-line no-console
        client.send(mutation.payload.endpoint, mutation.payload.turno).catch(err => console.error(err))
      }
    })

    store.subscribe((mutation, state) =>{
      if(state.turnos.connected && mutation.type === 'turnos/STOP_CONNECTION' && client.state !== 'Disconnected'){
        // eslint-disable-next-line no-console
        client.stop().then(() => {
          store.dispatch('turnos/connectionClosed')
        }).catch((err) => {
          store.dispatch('turnos/connectionError', err)
          handleError(err.toString())
        })
      }
    })

    function handleError(error) {
      let temporaryError = false
      // Network Errors
      if (error.indexOf('Network Error') >= 0) {
        temporaryError = true
        store.dispatch('snackbar/showSnackbar', ['Compruebe su conexión a internet y vuelva a intentar'])
        console.log(`Error de red: ${error}`)
        // Unauthorized
      } else if (error.indexOf('401') >= 0) {
        // If is not authorized, avoid unnecessary snackbar
        location.href = `${LOGIN_URL}?nombre=${SITE_NAME}&redirect=${location.href}`
        return
        // Server (Backend) Errors
      } else if (error.indexOf('404') >= 0) {
        store.dispatch('snackbar/showSnackbar', ['Error inesperado. Favor intente más tarde.'])
        console.log(`Not found: ${error}`)
      } else if (error.indexOf('499') >= 0) {
        store.dispatch('snackbar/showSnackbar', ['Error inesperado. Favor intente más tarde.'])
        console.log(`Client error: ${error}`)
      } else if (error.indexOf('503') >= 0) {
        store.dispatch('snackbar/showSnackbar', ['Servicio en mantenimiento. Vuelva a intentar más tarde.'])
      } else if (error.indexOf('500') >= 0) {
        store.dispatch('snackbar/showSnackbar', ['Error inesperado. Favor intente más tarde.'])
        console.log(`Internal server Error: ${error}`)
      }
        // Unknown Errors
      else {
        store.dispatch('snackbar/showSnackbar', ['Error inesperado. Favor intente más tarde.'])
        console.log(`Error desconocido: ${error}`)
      }
    }
  }
}